import React from 'react';
import { DevErrorBoundary } from './DevErrorBoundary';
import { useDevDebug } from '@/contexts';

interface Props {
  children: React.ReactNode;
}

export const ErrorBoundaryWrapper: React.FC<Props> = ({ children }) => {
  const { addError } = useDevDebug();
  
  return (
    <DevErrorBoundary
      onError={(error, errorInfo) => {
        if (import.meta.env.DEV) {
          addError(error, {
            componentStack: errorInfo.componentStack,
            type: 'React Error Boundary',
          });
        }
      }}
    >
      {children}
    </DevErrorBoundary>
  );
};
